var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide"}},[(_vm.gameOver)?_c('div',{staticClass:"game-over"},[_c('h1',[_vm._v("You Win!")]),_c('button',{on:{"click":_vm.startOver}},[_vm._v("Start Over")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }